export var K_ONE_MINUTES_IN_MILLISECONDS=60*1000;export var K_QUERY_CLIENT_OPTIONS_META_SHOULD_NOT_SHOW_ERROR_PROMPT={shouldNotShowErrorPrompt:true};